import { DATE_FORMATS_FNS } from "components";
import { formatDate, isDate } from "utils/dateHelperFunctions";

import type { DealerLocation } from "models";

export const getLocationName = (locationId: number | null, locations: DealerLocation[]) => locations.find(location => location.id === locationId)?.name || "";

export const getFormattedDate = (date: string | null | undefined) => {
  if (!date) return "";

  const isValidDate = !date.startsWith("0001-01-01T00:00:00");
  if (isDate(date) || isValidDate) return formatDate(date, DATE_FORMATS_FNS.dateMonthYear);
};
